import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import { DocumentType, MifidCategoryCode, UserInterface } from '../../../core';
import { DocumentTypeAdapter } from '../../client/helpers/serializer/adapters/document-type.adapter';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { MifidCategoryCodeAdapter } from '../../client/helpers/serializer/adapters/mifid-category-code.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { UserFunctions } from './user-functions';

@JsonObject('UserClient')
export class UserClient implements UserInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Code', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Surname', StringAdapter, true)
    private _surname: string = undefined;

    @JsonProperty('DocType', DocumentTypeAdapter, true)
    private _docType: DocumentType = undefined;

    @JsonProperty('DocId', StringAdapter, true)
    private _docId: string = undefined;

    @JsonProperty('DocExpirationDate', DateAdapter, true)
    private _docExpirationDate: Moment = undefined;

    @JsonProperty('Email', StringAdapter, true)
    private _email: string = undefined;

    @JsonProperty('Phone', StringAdapter, true)
    private _phone: string = undefined;

    @JsonProperty('Mifi2CategoryCode', MifidCategoryCodeAdapter, true)
    private _mifidCategoryCode: MifidCategoryCode = undefined;

    @JsonProperty('Mifid_competence', IdAdapter, true)
    private _mifidCompetenceId: Id = undefined;

    @JsonProperty('Mifid_competenceName', StringAdapter, true)
    private _mifidCompetenceName: string = undefined;

    @JsonProperty('ProfileId', IdAdapter, true)
    private _profileId: Id = undefined;

    @JsonProperty('ProfileName', StringAdapter, true)
    private _profileName: string = undefined;

    @JsonProperty('Date_last_test', DateAdapter, true)
    private _lastTestDate: Moment = undefined;

    @JsonProperty('DateNextTest', DateAdapter, true)
    private _nextTestDate: Moment = undefined;

    @JsonProperty('DaysDateNextTest', Number, true)
    private _daysToNextTest: number = undefined;

    @JsonProperty('AllowTransfers', Boolean, true)
    private _allowTransfers: boolean = undefined;

    get id(): Id {
        return this._id;
    }

    get code(): Id {
        return this._code;
    }

    get name(): string {
        return this._name;
    }

    get surname(): string {
        return this._surname;
    }

    get isAdmin(): boolean {
        return false;
    }

    set isAdmin(value: boolean) {}

    get isAdminPBC(): boolean {
        return false;
    }

    set isAdminPBC(value: boolean) {}

    get functions(): UserFunctions[] {
        return [];
    }

    get canEdit(): boolean {
        return true;
    }

    get canOperate(): boolean {
        return true;
    }

    get canSign(): boolean {
        return true;
    }

    get docType(): DocumentType {
        return this._docType;
    }

    get docId(): string {
        return this._docId;
    }

    get docExpirationDate(): Moment {
        return this._docExpirationDate;
    }

    get email(): string {
        return this._email;
    }

    get phone(): string {
        return this._phone;
    }

    get mifidCategoryCode(): MifidCategoryCode {
        return this._mifidCategoryCode;
    }

    get mifidCompetenceId(): Id {
        return this._mifidCompetenceId;
    }

    get mifidCompetenceName(): string {
        return this._mifidCompetenceName;
    }

    get profileId(): Id {
        if (this._profileId && String(this._profileId) === '0') {
            this._profileId = undefined;
        }

        return this._profileId;
    }

    get profileName(): string {
        return this._profileName;
    }

    get lastTestDate(): Moment {
        return this._lastTestDate;
    }

    get nextTestDate(): Moment {
        return this._nextTestDate;
    }

    get daysToNextTest(): number {
        return this._daysToNextTest;
    }

    get allowTransfers(): boolean {
        return this._allowTransfers;
    }
}
